import React from 'react';
import { OutboundLink } from 'gatsby-plugin-google-analytics';

function clientRandomizer(props) {
  const millsAds = [
    {
      image: '/rigoletto-2023/sponsors/jobs.jpg',
      link: 'https://www.utahopera.org/?utm_source=Mills+Publishing&utm_medium=Digital+Publication&utm_campaign=usuo+steve+jobs',
      alt: 'The Revolution of Steve Jobs',
      class: 'webFormat',
    },
    {
      image: '/rigoletto-2023/sponsors/thierry-final.jpg',
      link: 'https://utahsymphony.org/tickets/concerts-by-series/?utm_source=Mills+Publishing&utm_medium=Digital+Publication&utm_campaign=usuo+marketing+thierry-finals',
      alt: 'Thierrys Final Performances as Music Director',
      class: 'webFormat',
    },
    {
      image: '/rigoletto-2023/sponsors/grand-america.jpg',
      link: 'https://www.laurelslc.com?utm_source=Mills+Publishing&utm_medium=Digital+Publication&utm_campaign=usuo+grand+america',
      alt: 'Laurel Brasserie and Bar',
      class: 'webFormat',
    },
    {
      image: '/rigoletto-2023/sponsors/residence-inn.jpg',
      link: 'http://www.residenceinn.com/slcri?utm_source=Mills+Publishing&utm_medium=Digital+Publication&utm_campaign=usuo+residence+inn',
      alt: 'Residence Inn at Salt Lake City',
      class: 'webFormat',
    },
    {
      image: '/rigoletto-2023/sponsors/red-rock.jpg',
      link: 'http://www.residenceinn.com/slcri?utm_source=Mills+Publishing&utm_medium=Digital+Publication&utm_campaign=usuo+red+rock+brewery',
      alt: 'Red Rock Brewery',
      class: 'webFormat',
    },
    {
      image: '/rigoletto-2023/sponsors/education.jpg',
      link: 'https://www.usuo.org/hsclubs?utm_source=Mills+Publishing&utm_medium=Digital+Publication&utm_campaign=usuo+education',
      alt: 'Utah Opera Education',
      class: 'webFormat',
    },
    {
      image: '/rigoletto-2023/sponsors/ufs-2.jpg',
      link: 'https://utahfoodservices.com/?utm_source=Mills+Publishing&utm_medium=Digital+Publication&utm_campaign=usuo+utah+food+services',
      alt: 'Utah Food Services',
      class: 'webFormat',
    },
  ];

  const randomAd = millsAds[Math.floor(Math.random() * millsAds.length)];

  return (
    <>
      <hr />
      <br />
      <OutboundLink
        href={randomAd.link}
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src={randomAd.image}
          alt={randomAd.alt}
          className={randomAd.class}
        />
      </OutboundLink>
      <br />
      <br />
      <hr />
    </>
  );
}

export default clientRandomizer;
